import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Start each new page at the top (but leave back/forward alone)
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
};

export default ScrollToTop;
